import type { UserSliceI } from "../slices/user.slice";
import { setUserStateAction } from "../slices/user.slice";
import type { AppDispatch } from "../store";

const setUserState = (data: UserSliceI) => {
  return (dispatch: AppDispatch) => {
    dispatch(
      setUserStateAction({
        ...data,
      }),
    );
  };
};

export const userActions = {
  setUserState,
};
